import { SensorFirstScanResponseDTO, UserDeviceGroupDTO } from 'gen/model';

import { handleDiscoverRtc } from '@ui/Utils/scan/handleDiscoverRtc';

import { ScanStrategy } from '../types';

type RtcDiscoveryRaw = UserDeviceGroupDTO | SensorFirstScanResponseDTO | null;

function isUserDeviceGroupDTO(v: unknown): v is UserDeviceGroupDTO {
    return typeof v === 'object' && v !== null && 'id' in v;
}

function isSensorFirstScanResponseDTO(v: unknown): v is SensorFirstScanResponseDTO {
    return typeof v === 'object' && v !== null && 'device_group_id' in v;
}

function normalize(res: RtcDiscoveryRaw) {
    if (!res) {
        return null;
    }
    let groupId = '';
    if (isUserDeviceGroupDTO(res) && res.id) {
        groupId = res.id;
    } else if (isSensorFirstScanResponseDTO(res) && res.device_group_id) {
        groupId = res.device_group_id;
    }
    return {
        devicespecId: res.devicespec_id ?? null,
        groupId,
        raw: res,
    };
}

export const rtcStrategy: ScanStrategy = {
    kind: 'rtc',
    async start(signal, opts, onProgress) {
        if (!opts.instanceId) {
            throw new Error('Instance not selected');
        }
        if (!opts.instance) {
            throw new Error('Instance object not provided');
        }
        onProgress({ progress: 5, title: 'Connecting to instance' });
        const res = (await handleDiscoverRtc(opts.instance, signal)) as RtcDiscoveryRaw;
        if (signal.aborted) {
            throw new Error('Aborted');
        }
        const normalized = normalize(res);
        if (!normalized?.groupId) {
            throw new Error('No device found');
        }
        onProgress({ progress: 95, title: 'Finishing' });
        return normalized;
    },
};
